import React from 'react';
import clsx from 'clsx';

import { Dialog } from '@shared/components';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import SuccessIcon from '@assets/icons/done-green.svg';

import useStyles from './style';

const noop = () => {};

const SyncSuccessComponent = ({
  isOpen = false,
  onClose = noop,
  onReset = noop,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.syncSuccesModal }}
      open={isOpen}
      onClose={onClose}
    >
      <Dialog.Title hasClose />
      <Dialog.Content className='align-center'>
        <div className='mt-5 pl-5 pr-5'>
          <Typography variant='h5' className='text-bold'>
            SYNC COMPLETED
          </Typography>
          <div className='mt-10 mb-10'>
            <img src={SuccessIcon} width='90' height='84' />
          </div>

          <Typography
            variant='h6'
            className={clsx('mt-2 mb-5', classes.successText)}
          >
            Success! Your data has been uploaded.
          </Typography>
          <Typography variant='body2'>
            Would you like to return to the home screen?
          </Typography>
          <div className='mt-5'>
            <Button
              variant='contained'
              color='primary'
              className='bold-font'
              onClick={onReset}
            >
              Home
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

export default SyncSuccessComponent;
